<template>
    <div class="official_web">
        <Header/>
        <router-view :key="key"/>
        <Footer/>
    </div>
</template>
<script>
import Header from '@/components/views/header'
import Footer from '@/components/views/footer'
export default {
    name:'index',
    data(){
        return{

        }
    },
    components: {
     Header,
     Footer,
  },
  computed: {
  key() {
    //解决同一组件路由跳转，数据不刷新问题
    return this.$route.name !== undefined? this.$route.name +new Date(): this.$route +new Date()
  }
},
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/index.vue